
import React from 'react';
import './Toolbar.css';

interface ToolbarProps {
    onColorChange: (color: string) => void;
    onLineWidthChange: (width: number) => void;
    onClear: () => void;
    onFinish: () => void;
    isFinished: boolean;
    currentColor: string;
    currentLineWidth: number;
}

const COLORS = ['#FFFFFF', '#000000', '#FF0000', '#00FF00', '#0000FF', '#FFFF00', '#FF00FF', '#00FFFF'];
const LINE_WIDTHS = [2, 5, 10, 20];

export const Toolbar: React.FC<ToolbarProps> = ({ onColorChange, onLineWidthChange, onClear, onFinish, isFinished, currentColor, currentLineWidth }) => {
    return (
        <div className="toolbar">
            <div className="toolbar-section">
                <span>Color:</span>
                <div className="color-palette">
                    <div 
                        className={`color-swatch eraser ${currentColor === 'eraser' ? 'selected' : ''}`}
                        onClick={() => onColorChange('eraser')}
                    >
                        <i className="fa-solid fa-eraser"></i>
                    </div>
                    {COLORS.map(color => (
                        <div 
                            key={color}
                            className={`color-swatch ${currentColor === color ? 'selected' : ''}`}
                            style={{ backgroundColor: color }}
                            onClick={() => onColorChange(color)}
                        />
                    ))}
                </div>
            </div>
            <div className="toolbar-section">
                <span>Size:</span>
                <div className="line-widths">
                    {LINE_WIDTHS.map(width => (
                        <div 
                            key={width}
                            className={`width-dot-container ${currentLineWidth === width ? 'selected' : ''}`}
                            onClick={() => onLineWidthChange(width)}
                        >
                            <div className="width-dot" style={{ width: width, height: width }} />
                        </div>
                    ))}
                </div>
            </div>
            <div className="toolbar-section actions">
                 <button className="pixel-button" onClick={onClear}>清除</button>
                 <button 
                    className="pixel-button" 
                    onClick={onFinish}
                    disabled={isFinished}
                >
                    {isFinished ? '等待中...' : '完成繪畫'}
                </button>
            </div>
        </div>
    );
};

